import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'vendorName',
})
export class VendorNamePipe implements PipeTransform {
  transform(id: string | number, vendor_data: any): string {
    if (vendor_data.length > 0) {
      let vendor = vendor_data.find((ele: any) => ele.id === id);
      if (vendor) {
        return vendor.name;
      } else {
        return 'Unknown Vendor';
      }
    } else {
      return 'Vendor Data not found.';
    }
  }
}
